import { useState, useEffect } from 'react'
import { X } from 'lucide-react'
import { Modal } from '@meiuca/ui-components'
import { LoginForm } from './LoginForm'
import { SignUpFlow } from './SignUpFlow'

interface AuthModalProps {
  open: boolean
  onClose: () => void
  onSuccess?: () => void
  initialMode?: 'login' | 'signup'
}

export function AuthModal({ open, onClose, onSuccess, initialMode = 'login' }: AuthModalProps) {
  const [mode, setMode] = useState<'login' | 'signup'>(initialMode)

  // Reset to initial mode when modal opens
  useEffect(() => {
    if (open) {
      setMode(initialMode)
    }
  }, [open, initialMode])

  const handleSuccess = () => {
    onSuccess?.()
  }

  const handleSwitchToSignup = () => {
    setMode('signup')
  }

  const handleSwitchToLogin = () => {
    setMode('login')
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="md"
      closeOnOverlayClick={true}
      showCloseButton={false}
    >
      <div className="relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-0 right-0 p-2 hover:bg-background-secondary rounded-lg transition-colors z-10"
        >
          <X className="w-5 h-5 text-text-tertiary" />
        </button>

        {/* Auth Form */}
        {open && (
          <>
            {mode === 'login' ? (
              <LoginForm
                onSuccess={handleSuccess}
                onSignUpClick={handleSwitchToSignup}
              />
            ) : (
              <SignUpFlow
                onSuccess={handleSuccess}
                onLoginClick={handleSwitchToLogin}
              />
            )}
          </>
        )}
      </div>
    </Modal>
  )
}
